<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M32 43.7581L20.2605 32L32 20.2419L43.7581 32L32 43.7581ZM32 0C25.671 0 19.4842 1.87678 14.2218 5.39298C8.95942 8.90918 4.85789 13.9069 2.43588 19.7541C0.0138808 25.6014 -0.619847 32.0355 0.61488 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5498 62.1504 25.7571 63.3851C31.9645 64.6198 38.3986 63.9861 44.2459 61.5641C50.0931 59.1421 55.0908 55.0406 58.607 49.7782C62.1232 44.5158 64 38.329 64 32C64 23.5131 60.6286 15.3737 54.6274 9.37258C48.6263 3.37142 40.4869 0 32 0"
		fill="currentColor"
	/>
</svg>
